export default {
  'forms.validation.error.invalid_request_timeout':
    'Request timeout must be between 50 and 5000',
  'forms.validation.active_days.required':
    'At least one active day must be selected',
  'forms.validation.start_time_required': 'Start time is required',
  'forms.validation.end_time_range':
    'End time must be between {{minimum}} and {{maximum}} hours after start time'
}
